var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SearchBanner",
    {
      attrs: {
        "store-namespace": "restaurantsSearchBanner",
        id: _vm.id,
        title: _vm.$t("10034053.Home_TitleDateSearch"),
        description: _vm.$t("10034059.Home_SubtextDateRestaurants"),
        "image-src": _vm.image,
      },
    },
    [
      _c("SearchBannerForm", {
        attrs: {
          "store-namespace": "restaurantsSearchBanner",
          id: _vm.id + "-form",
          labels: {
            city: _vm.$t("10034062.Home_InputLocation"),
            cityDrawer: _vm.$t(
              "43948.InspirationsClient_RestaurantLocationDrawerTitle"
            ),
            date: _vm.$t("10034056.Home_InputDate"),
            dateDrawer: _vm.$t(
              "43949.InspirationsClient_RestaurantDateDrawerTitle"
            ),
            amount: _vm.$t("10034063.Home_InputAmountPerson"),
            amountDrawer: _vm.$t(
              "43950.InspirationsClient_RestaurantPeopleDrawerTitle"
            ),
            submit: _vm.$t("10034064.Home_ButtonSearchRestaurant"),
          },
          "calendar-config": {
            type: "restaurants",
            flow: "search-bar-restaurants",
          },
        },
        on: { submit: _vm.handleSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }